import { IQuestion } from './IQuestion';

// we use this to infer the answer type
interface IMinimalQuestion<TAnswer = any> {
    questionId: string;
    answer?: TAnswer
}

export class QuestionHelper {
    constructor(private questionsWithAnswers: IQuestion[]) { }

    getAnswer = <TQuestion extends IMinimalQuestion >({ questionId }: TQuestion): TQuestion['answer'] => {
        const found = this.questionsWithAnswers.find(q => q.questionId === questionId);
        if (!found){
            throw new Error(`did not find a question with id ${questionId}`);
        }
        return found.answer;
    };

    getQuestion = <TQuestion extends IQuestion >({ questionId }: TQuestion): TQuestion => {
        const found = this.questionsWithAnswers.find(q => q.questionId === questionId);
        if (!found){
            throw new Error(`did not find a question with id ${questionId}`);
        }
        return found as TQuestion;
    };

    isSameQuestionId = (question1: IQuestion, question2: IQuestion) => {
        return question1.questionId === question2.questionId;
    };
}
